export default () => {
    const BREAKPOINT = 1024;
    let lastWidth = window.innerWidth;

    function crossedBreakpoint(oldWidth, newWidth) {
        return (
            (oldWidth < BREAKPOINT && newWidth >= BREAKPOINT) ||
            (oldWidth >= BREAKPOINT && newWidth < BREAKPOINT)
        );
    }

    function handleChange() {
        const newWidth = window.innerWidth;

        if (crossedBreakpoint(lastWidth, newWidth)) {
            const loader = document.getElementById('loading-change-orientation');
            if (loader) {
                loader.classList.remove('hidden');
                setTimeout(() => {
                    location.reload();
                }, 1000);
            }
        }

        lastWidth = newWidth;
    }

    window.addEventListener("resize", handleChange);
    window.addEventListener("orientationchange", handleChange);
};